module.exports = "/static/assets/8997b5c23c84a4182883356bf17aae34.png";